<myqq-routed-modal
  [hideFooter]="true"
  [modalSize]="'sm'"
  (modalClose)="handleCancel()"
>
  <span modal-header>
    Employee ID
  </span>
  <div *ngIf="account$ | async as account">
    <div class="add-employee-id-container">
      <h2>Enter your Employee ID</h2>
      <p class="add-employee-id-directions">
        Enter your employee ID below to complete linking your employer benefits.
        You can return to this by going to Account Employer Benefit Easy Link.
      </p>
      <input
        class="employee-input"
        [formControl]="employeeIdInput"
        type="text"
        [maxLength]="employeeIdLength"
        [size]="employeeIdLength"
        #employeeID
      />
      <p>
        <button
          mat-flat-button
          color="primary"
          class="raised submit-btn"
          (click)="handleSubmit(employeeID.value, account)"
          [disabled]="employeeIdInput.value.length < 2"
        >
          Submit
        </button>
      </p>

      <div class="seperator">
        <p>If you don't have your employee ID contact your HR Department</p>
      </div>
    </div>
  </div>
</myqq-routed-modal>
